import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { WHATSAPP_ENABLED } from "@/lib/contact";

// Toggle a global class so all WhatsApp CTAs are hidden via CSS when disabled.
// Keeps every component untouched (no conditional JSX everywhere).
if (typeof document !== "undefined" && !WHATSAPP_ENABLED) {
  document.documentElement.classList.add("wa-off");
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
